module.exports = __webpack_public_path__ + "static/media/pizza.62024e54.svg";